import {
	SanityFlagshipFundStrategies,
	SanityFlagshipStrategiesSectionResponse
} from 'types/sanity/marketing-components';
import { FlagshipFundStrategies } from '@api/sanity/graphql/queries/flagship-fund-strategies';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

export async function getFlagshipFundStrategies(): Promise<SanityFlagshipFundStrategies | null> {
	const { data } = await useQuery<SanityFlagshipStrategiesSectionResponse>({
		client: villusClient,
		query: FlagshipFundStrategies,
		tags: ['flagship_fund_strategies']
	}).execute();

	return data?.allFlagshipFundStrategiesContent[0] ?? null;
}
